import React from 'react';
import { ShowInboundData } from './ShowInboundData';
import { Helmet } from 'react-helmet';

export function InboundConfig(): JSX.Element {
  return (
    <div>
      <Helmet>
        <title>Dashboard - Inbound Edit</title>
      </Helmet>
      <ShowInboundData />
    </div>
  );
}
